import { render, staticRenderFns } from "./ChipFilter.vue?vue&type=template&id=050a557d&scoped=true&"
import script from "./ChipFilter.vue?vue&type=script&lang=js&"
export * from "./ChipFilter.vue?vue&type=script&lang=js&"
import style0 from "./ChipFilter.vue?vue&type=style&index=0&id=050a557d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a557d",
  null
  
)

export default component.exports